module.exports = require('./lib/is-in-view');
